import { render, staticRenderFns } from "./SigUserSelection.vue?vue&type=template&id=00a39752&"
import script from "./SigUserSelection.vue?vue&type=script&lang=js&"
export * from "./SigUserSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports